<template>
<div class="diandian-home">
    <div v-if="isPc" class="diandian-pc">
        <div class="dh-nav">
            <div class="nav-main">
                <div class="dd-logo"></div>
                <div class="dd-download">
                    <i></i>下载点点
                    <div class="nav-qrcode">
                        <div class="qrcode-main"></div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="dh-banner-pc" class="dh-banner-pc">
            <div class="dh-slider-background">
                <div class="dh-bg-1" :class="{'anima_slider':isDs_1_bg,'anima_slider_reverse':isDs_1_bg_rs}"></div>
                <div class="dh-bg-2" :class="{'anima_slider':isDs_2_bg,'anima_slider_reverse':isDs_2_bg_rs}"></div>
                <div class="dh-bg-3" :class="{'anima_slider':isDs_3_bg,'anima_slider_reverse':isDs_3_bg_rs}"></div>
                <div class="dh-bg-4" :class="{'anima_slider':isDs_4_bg,'anima_slider_reverse':isDs_4_bg_rs}"></div>
                <div class="dh-bg-5" :class="{'anima_slider':isDs_5_bg,'anima_slider_reverse':isDs_5_bg_rs}"></div>
            </div>
            <div v-show="isDs_1_bg" class="dh-slider dh-slider-1">
                <div id="scene" class="ss-main">
                    <div data-depth="0.4">
                        <div class="slide-text" :class="{'fadeInUp':isDs_1,'bounceOutUp':!isDs_1}">
                            <h1 class="">点点</h1>
                            <h2>一站式生活消费金融神器</h2>
                            <p>Diandian Finance</p>
                            <b></b>
                        </div>
                    </div>
                    <div id="scene-sp-1" class="slide-phone anim_dh_phone" :class="{'bounceInUp':isDs_1,'bounceOutUp2':!isDs_1}">
                        <div data-depth="0.45">
                            <img alt="点点-Banner" class="sp-1" :class="{'anima_round1':isDs_1,'anima_round1_reverse':!isDs_1}" width="82" src="../assets/images/symbols-1.png" />
                        </div>
                        <div data-depth="0.2">
                            <img alt="点点-Banner" class="sp-2" :class="{'anima_round2':isDs_1,'anima_round2_reverse':!isDs_1}" width="68" src="../assets/images/symbols-2.png" />
                        </div>
                        <div data-depth="0.3">
                            <img alt="点点-Banner" class="sp-3" :class="{'anima_round3':isDs_1,'anima_round3_reverse':!isDs_1}" width="88" src="../assets/images/symbols-3.png" />
                        </div>
                        <div data-depth="0.125">
                            <img alt="点点-Banner" class="sp-4" :class="{'anima_phone':isDs_1,'anima_phone_reverse':!isDs_1}" width="258" src="../assets/images/symbols-reflections.png" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="isDs_2_bg" class="dh-slider dh-slider-2">
                <div class="ss-main">
                    <div id="scene_2" class="h-auto zindex-s">
                        <div data-depth="0.4">
                            <div class="slide-text" :class="{'fadeInUp':isDs_2,'bounceOutUp':!isDs_2}">
                                <h1 class="">借钱还卡</h1>
                                <h2>还逾期,一键帮还信用卡</h2>
                                <p>Diandian Finance</p>
                                <b></b>
                            </div>
                        </div>
                    </div>
                    <div id="scene-sp-2" class="slide-card" :class="{'bounceInUp':isDs_2,'bounceOutUp2':!isDs_2}">
                        <div>
                            <div class="q-dd-1" :class="{'anima_q_dd_2':isDs_2}"></div>
                        </div>
                        <div>
                            <div class="q-dd-2" :class="{'anima_q_dd_1':isDs_2}"></div>
                        </div>
                        <div data-depth="0.35">
                            <div class="r-c-1" :class="{'zoomIn':isDs_2}"></div>
                        </div>
                        <div data-depth="0.15">
                            <div class="r-c-2" :class="{'zoomIn':isDs_2}"></div>
                        </div>
                        <div data-depth="0.25">
                            <div class="hb hb-1" :class="{'anima_hb_1':isDs_2}"></div>
                        </div>
                        <div data-depth="0.2">
                            <div class="hb hb-2" :class="{'anima_hb_2':isDs_2}"></div>
                        </div>
                        <div data-depth="0.4">
                            <div class="hb hb-3" :class="{'anima_hb_3':isDs_2}"></div>
                        </div>
                        <div data-depth="0.5">
                            <div class="hb hb-4" :class="{'anima_hb_4':isDs_2}"></div>
                        </div>
                        <div data-depth="0.25">
                            <div class="hb hb-5" :class="{'anima_hb_5':isDs_2}"></div>
                        </div>
                        <div data-depth="0.45">
                            <div class="symbols-card" :class="{'anima_card':isDs_2}"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="isDs_3_bg" class="dh-slider dh-slider-3">
                <div class="ss-main">
                    <div id="scene_3" class="h-auto zindex-s">
                        <div data-depth="0.4">
                            <div class="slide-text" :class="{'fadeInUp':isDs_3,'bounceOutUp':!isDs_3}">
                                <h1 class="">借一点</h1>
                                <h2>额度高至20万,<br />一秒审核3秒放款</h2>
                                <p>Diandian Finance</p>
                                <b></b>
                            </div>
                        </div>
                    </div>
                    <div id="scene-sp-3" class="jk-main banner-box" :class="{'bounceInUp':isDs_3,'bounceOutUp2':!isDs_3}">
                        <div data-depth="0.1">
                            <div class="jk jk-round-bg" :class="{'jk_round':isDs_3}"></div>
                        </div>
                        <div data-depth="0.2">
                            <div class="jk jk-icon" :class="{'zoomIn':isDs_3}"></div>
                        </div>
                        <div data-depth="0.4">
                            <div class="jk jk-r-1" :class="{'zoomIn':isDs_3}"></div>
                        </div>
                        <div data-depth="0.2">
                            <div class="jk jk-r-2" :class="{'zoomIn':isDs_3}"></div>
                        </div>
                        <div data-depth="0.3">
                            <div class="jk jk-r-3" :class="{'zoomIn':isDs_3}"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="isDs_4_bg" class="dh-slider dh-slider-4">
                <div class="ss-main">
                    <div id="scene_4" class="h-auto zindex-s">
                        <div data-depth="0.4">
                            <div class="slide-text" :class="{'fadeInUp':isDs_4,'bounceOutUp':!isDs_4}">
                                <h1 class="">点点闪付</h1>
                                <h2>点点闪付,买单超舒服</h2>
                                <p>Diandian Finance</p>
                                <b></b>
                            </div>
                        </div>
                    </div>
                    <div id="scene-sp-4" class="banner-box" :class="{'bounceInUp':isDs_4,'bounceOutUp2':!isDs_4}">
                        <div data-depth="0.2">
                            <div class="pos pos-hb-bg">

                            </div>
                        </div>
                        <div data-depth="0.4">
                            <div class="pos pos-bg">

                            </div>
                        </div>
                        <div data-depth="0.5">
                            <div class="pos pos-r-1">

                            </div>
                        </div>
                        <div data-depth="0.3">
                            <div class="pos pos-r-2">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="isDs_5_bg" class="dh-slider dh-slider-5">
                <div class="ss-main">
                    <div id="scene_5" class="h-auto zindex-s">
                        <div data-depth="0.4">
                            <div class="slide-text" :class="{'fadeInUp':isDs_5,'bounceOutUp':!isDs_5}">
                                <h1 class="">生活所需 一站完成</h1>
                                <h2>话费充值／加油卡／<br />水电煤／游戏充值</h2>
                                <p>Diandian Finance</p>
                                <b></b>
                            </div>
                        </div>
                    </div>
                    <div id="scene-sp-5" class="banner-box" :class="{'bounceInUp':isDs_5,'bounceOutUp2':!isDs_5}">
                        <div data-depth="0.1" class="lw box-bg"></div>
                        <div data-depth="0.3">
                            <div class="lw box-liwu">
                                <div class="bl-h"></div>
                                <div class="scene_6" style="height:100%" id="scene_6">
                                    <div data-depth="0.2">
                                        <div class="bl-l"></div>
                                    </div>
                                </div>
                                <div class="bl-q"></div>
                            </div>
                        </div>
                        <div data-depth="0.4">
                            <div class="pos pos-bg"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dh-pagination">
                <div @click="paginationHandle($event,index)" v-for="(item,index) in page" class="dh-page">
                    <span class="m-page"></span>
                </div>
            </div>
        </div>

        <div class="dh-life">
            <div class="dh-title">
                <strong>DIANDIAN</strong>
                <p>点点</p>
                <span>让生活，好一点</span>
            </div>
            <div class="dh-sm-download">
                <div @mouseover="dsMouseOverHandle" @mouseout="dsMouseOutHandle" class="dd-sd">
                    <div class="dd-sd-radio" :class="{'dsRadio':isDsRadio}"></div>
                    <strong>
                        扫码下载<i></i>
                    </strong>
                </div>
                <p>下载点点手机客户端，即刻开启品质生活</p>
                <div v-if="isQrcode" class="qrcode-box">
                    <div class="ra"></div>
                    <div class="qrcode-container">
                        <div class="qrcode-main">
                            <div class="qrcode"></div>
                        </div>
                        <span>扫码下载点点手机客户端</span>
                    </div>
                </div>
            </div>
            <div class="hz-phone"></div>
            <canvas id="box"></canvas>
        </div>

        <div class="dh-about">
            <div class="dh-title">
                <strong>ABOUT US</strong>
                <p>关于点点</p>
            </div>
            <div class="about-main">
                <ul>
                    <li>
                        <div class="ab-icon"></div>
                        <h2>智能生活</h2>
                        <p>国内领先的智能生活金融服务</p>
                    </li>
                    <li>
                        <div class="ab-icon"></div>
                        <h2>综合服务</h2>
                        <p>提供最优质的综合生活与金融连接服务</p>
                    </li>
                    <li>
                        <div class="ab-icon"></div>
                        <h2>深度合作</h2>
                        <p>与国内众多知名金融机构达成深度合作</p>
                    </li>
                </ul>
            </div>
        </div>

        <div class="dh-coop">
            <div class="dh-title">
                <strong>PARTNER</strong>
                <p style="color:#ffffff">战略合作</p>
            </div>
            <div class="dh-wa">
                <div class="dw-l"></div>
                <div class="dw-r"></div>
            </div>
            <p class="coop-text">众安保险为点点的深度战略合作伙伴。众安（股票代码:HK06060）是由蚂蚁金服、腾讯与中国平安发起设立，并为点点用户提供全面账户信息安全保障服务。</p>
        </div>

        <div class="dh-partner">
            <div class="dh-title">
                <strong>PARTNERS</strong>
                <p>合作伙伴</p>
            </div>
            <div class="partner"></div>
        </div>

        <div class="dh-footer">
            <div class="footer-main">
                <div class="footer-logo"></div>
                <div class="footer-download">
                    <div class="download-qr-code"></div>
                    <p>扫一扫下载点点APP</p>
                </div>
                <div class="footer-download">
                    <div class="wx-qr-code"></div>
                    <p>扫一扫关注点点官微</p>
                </div>
            </div>
            <div class="footer-text">
                Copyright © 2017 - 2018 Diandian 点点版权所有 粤ICP备17079095号-2
            </div>
        </div>
    </div>
    <div v-if="isMobile" class="diandinan-mobile">
        <div class="mobile-nav">
            <div class="nav-main">
                <div class="dd-logo"></div>
                <div @click="downloadMobile" class="dd-download">
                    <i></i>下载点点
                </div>
            </div>
        </div>
        <div class="mobile-banner">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide>
                    <img src="../assets/images/mobile/banner-phone1.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="../assets/images/mobile/banner-phone2.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="../assets/images/mobile/banner-phone3.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="../assets/images/mobile/banner-phone4.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="../assets/images/mobile/banner-phone5.jpg" alt="">
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-pagination my-swiper-pagination" slot="pagination"></div>
                <!-- <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div> -->
            </swiper>
        </div>
        <div class="dh-life">
            <div class="dh-title">
                <strong>DIANDIAN</strong>
                <p>点点</p>
                <span>让生活，好一点</span>
            </div>
            <div class="hz-phone"></div>
        </div>
        <div class="dh-about">
            <div class="dh-title">
                <strong>ABOUT US</strong>
                <p>关于点点</p>
            </div>
            <div class="about-main">
                <ul>
                    <li>
                        <div class="ab-icon"></div>
                        <h2>智能生活</h2>
                        <p>国内领先的智能生活金融服务</p>
                    </li>
                    <li>
                        <div class="ab-icon"></div>
                        <h2>综合服务</h2>
                        <p>提供最优质的综合生活与金融连接服务</p>
                    </li>
                    <li>
                        <div class="ab-icon"></div>
                        <h2>深度合作</h2>
                        <p>与国内众多知名金融机构达成深度合作</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="dh-coop">
            <div class="dh-title">
                <strong>PARTNER</strong>
                <p style="color:#ffffff">战略合作</p>
            </div>
            <div class="dh-wa">
                <div class="dw-l"></div>
                <div class="dw-r"></div>
            </div>
            <p class="coop-text">众安保险为点点的深度战略合作伙伴。众安（股票代码:HK06060）是由蚂蚁金服、腾讯与中国平安发起设立，并为点点用户提供全面账户信息安全保障服务。</p>
        </div>
        <div class="dh-partner">
            <div class="dh-title">
                <strong>PARTNERS</strong>
                <p>合作伙伴</p>
            </div>
            <div class="partner"></div>
        </div>
        <div class="dh-footer">
            <div class="footer-main">
                <div class="footer-logo"></div>
                <div class="qrcode-box">
                    <div class="footer-download">
                        <div class="download-qr-code"></div>
                        <p>扫一扫下载点点APP</p>
                    </div>
                    <div class="footer-download">
                        <div class="wx-qr-code"></div>
                        <p>扫一扫关注点点官微</p>
                    </div>
                </div>
            </div>
            <div class="footer-text">
                <p>Copyright © 2017 - 2018 Diandian</p>
                <p>点点版权所有 粤ICP备17079095号-2</p>
            </div>
        </div>

        <!-- <div v-if="false" class="dh-banner">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide class="dh-1">
                    <div class="ss-main">
                        <div class="slide-text" :data-swiper-parallax-x="-300" :data-swiper-parallax-scale="0.5" :data-swiper-parallax-opacity="0.2">
                            <h1 class="ani" :data-swiper-parallax-y="-100" swiper-animate-effect="tada" swiper-animate-duration="0.5s">点点</h1>
                            <h2>一站式生活消费金融神器</h2>
                            <p>Diandian Finance</p>
                            <b :data-swiper-parallax-x="150"></b>
                        </div>
                        <div :data-swiper-parallax-x="400" class="slide-phone">
                            <img :data-swiper-parallax-x="210" :data-swiper-parallax-y="-50" :data-swiper-parallax-scale="0.5" :data-swiper-parallax-opacity="0.1" width="82" src="../assets/images/symbols-1.png" />
                            <img :data-swiper-parallax-x="150" :data-swiper-parallax-y="50" :data-swiper-parallax-scale="0.25" :data-swiper-parallax-opacity="0.1" width="68" src="../assets/images/symbols-2.png" />
                            <img :data-swiper-parallax-x="-180" :data-swiper-parallax-y="-50" :data-swiper-parallax-scale="0.25" :data-swiper-parallax-opacity="0.1" width="88" src="../assets/images/symbols-3.png" />
                            <img width="258" src="../assets/images/symbols-reflections.png" />
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide class="dh-2">
                    <canvas ref="waves" width="500px" height="500px" id="box"></canvas>
                </swiper-slide>
                <swiper-slide class="dh-3">
                </swiper-slide>

                <div class="swiper-pagination my-swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
        </div> -->
    </div>
</div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import {
    swiper,
    swiperSlide
} from 'vue-awesome-swiper'
import {
    os
} from '../utils/tool'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data() {
        const _vue = this;
        return {
            isPc: false,
            isMobile: false,
            isDs_1: true,
            isDs_1_bg: true,
            isDs_1_bg_rs: false,
            isDs_2: false,
            isDs_2_bg: false,
            isDs_2_bg_rs: false,
            isDs_3: false,
            isDs_3_bg: false,
            isDs_3_bg_rs: false,
            isDs_4: false,
            isDs_4_bg: false,
            isDs_4_bg_rs: false,
            isDs_5: false,
            isDs_5_bg: false,
            isDs_5_bg_rs: false,
            nowIndex: 0,
            page: 5,
            timer: null,
            isMoveing: true,
            isFixed: false,
            isDsRadio: false,
            isQrcode: false,
            autoPage: 6000,
            nowDownloadUrl: '',
            swiperOption: {
                // direction: 'vertical',
                // mousewheel: true,
                // parallax: true,
                // touchRatio: 0.5,
                // resistanceRatio: 0,
                speed: 450,
                height: 420,
                // autoplay: {
                //     delay: 5000
                // },
                loop: true,
                // effect: 'fade',
                // allowTouchMove: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    slideChange: function(e) {

                        // console.log(nowActiveIndex, this.activeIndex, 'index');
                    },
                    transitionEnd: function() {
                        if (_vue.swiperOption.autoplay) {
                            this.autoplay.start()
                        }
                    }
                }
            }
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        }
    },
    watch: {
        nowIndex(n, o) {
            // console.log('isDs_'+eval(n+1)+'','isDs_'+eval(o+1)+'_rs')
            this['isDs_' + eval(o + 1) + ''] = false
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this['isDs_' + eval(n + 1) + ''] = true
                this['isDs_' + eval(n + 1) + '_bg'] = true
                this['isDs_' + eval(n + 1) + '_bg_rs'] = false

                this['isDs_' + eval(o + 1) + '_bg'] = false
                this['isDs_' + eval(o + 1) + '_bg_rs'] = true

                this.parallax()
                this.isMoveing = true
            }, 1000)
            //分页
            // this.moveBar(this.aMPage[o],-100,1)
            //清除上一个定时器
            cancelAnimationFrame(this.aMPage[o].raf);
            this.setCss3(this.aMPage[o], {
                transform: 'translate3d(-100%,0,0)'
            })
            this.moveBar(this.aMPage[n], 0, 6000)
        }
    },
    created() {
        document.title = '点点-让生活好一点';
        var clientHeight = document.documentElement.clientHeight || document.body.clientHeight
        this.bannerPcHeight = clientHeight - 80
        this.bannerPcHeight = this.bannerPcHeight < 678 ? 678 : this.bannerPcHeight
        // console.log(this.swiperOption.height);
        if (os().isIos || os().isAndroid) {
            this.isMobile = true
        } else {
            this.isPc = true
        }
    },
    mounted() {
        // this.swiper.slideTo(1, 1000, false);
        // this.swiper.$wrapperEl[0].style.height = this.swiperOption.height + 'px';
        if (os().isIos || os().isAndroid) {
            // versionUrl((url) => {
            //     this.nowDownloadUrl = url
            // })
        } else {
            this.pfx()
            this.initElement()
            this.resetHeight()
            this.parallax()
        }


        console.log(this.transform);

    },
    methods: {
        pfx() {
            var prefix = (function() {
                var tempDom = document.createElement('div').style,
                    prefixStrArr = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
                    sPre;
                for (var i = 0; i < prefixStrArr.length; i++) {
                    if (prefixStrArr[i] + 'ransform' in tempDom) {
                        sPre = prefixStrArr[i].substring(0, prefixStrArr[i].length - 1);
                        window.cssPrefix = sPre ? sPre : '';
                        window.css_Prefix = sPre ? '-' + sPre.toLowerCase() + '-' : '';
                    }
                }
                tempDom = null;
                return function(style) {
                    if (sPre === '') return style;
                    style = style.charAt(0).toUpperCase() + style.substring(1);
                    return sPre + style;
                }
            })();
            var _vTransitionEnd = {
                '': 'transitionend',
                'webkit': 'webkitTransitionEnd',
                'Moz': 'transitionend',
                'O': 'otransitionend',
                'ms': 'MSTransitionEnd'
            };
            this.transform = prefix('transform')
            // transition = prefix('transition'),
            // transitionEnd = _vTransitionEnd[window.cssPrefix],
            // transitionDelay = prefix('transitionDelay'),
            // transitionDuration = prefix('transitionDuration'),
            // transitionProperty = prefix('transitionProperty'),
            // transitionTimingFunction = prefix('transitionTimingFunction');
        },
        parallax() {
            // parallax.destroy();
            // parallax = null;
            //page1
            var scene = document.getElementById('scene')
            var parallaxInstance = new Parallax(scene, {
                // relativeInput: true
            });
            parallaxInstance.friction(0.075, 0.075)
            parallaxInstance.origin(1, 1)

            var scene1_2 = document.getElementById('scene-sp-1')
            var parallaxInstance1_2 = new Parallax(scene1_2);
            parallaxInstance1_2.friction(0.075, 0.075)

            var scene2 = document.getElementById('scene_2');
            var parallaxInstance2_1 = new Parallax(scene2);
            parallaxInstance2_1.friction(0.075, 0.075)

            var scene2_2 = document.getElementById('scene-sp-2')
            var parallaxInstance2_2 = new Parallax(scene2_2);
            parallaxInstance2_2.friction(0.075, 0.075)

            var scene3 = document.getElementById('scene_3')
            var parallaxInstance3_1 = new Parallax(scene3);
            parallaxInstance3_1.friction(0.075, 0.075)

            var scene3_2 = document.getElementById('scene-sp-3')
            var parallaxInstance3_2 = new Parallax(scene3_2);
            parallaxInstance3_2.friction(0.075, 0.075)

            var scene4 = document.getElementById('scene_4')
            var parallaxInstance4 = new Parallax(scene4);
            parallaxInstance4.friction(0.075, 0.075)

            var scene4_1 = document.getElementById('scene-sp-4')
            var parallaxInstance4_1 = new Parallax(scene4_1);
            parallaxInstance4_1.friction(0.075, 0.075)

            var scene5 = document.getElementById('scene_5')
            var parallaxInstance5 = new Parallax(scene5);
            parallaxInstance5.friction(0.075, 0.075)

            var scene5_1 = document.getElementById('scene-sp-5')
            var parallaxInstance5_1 = new Parallax(scene5_1);
            parallaxInstance5_1.friction(0.075, 0.075)

            var scene6 = document.getElementById('scene_6')
            var parallaxInstance6 = new Parallax(scene6);
            parallaxInstance6.friction(0.075, 0.075)

        },
        initElement() {
            this.aMPage = document.getElementsByClassName('m-page')
            this.moveBar(this.aMPage[0], 0, 6000)
        },
        resetHeight() {
            var dhBannerPc = this.$refs['dh-banner-pc'];
            var aDhSlider = dhBannerPc.getElementsByClassName('dh-slider')
            for (var i = 0; i < aDhSlider.length; i++) {
                aDhSlider[i].style.height = this.bannerPcHeight + 'px'
            }
        },
        paginationHandle(e, index) {
            if (this.isMoveing) {
                this.nowIndex = index;
                this.isMoveing = false
            }
        },
        scrollHandle() {
            window.addEventListener('scroll', () => {
                var nowScrollTop = document.documentElement.scrollTop + document.body.scrollTop;
                // console.log(nowScrollTop);
                if (nowScrollTop > 0) {
                    this.isFixed = true
                } else {
                    this.isFixed = false
                }
            }, false)
        },
        dsMouseOverHandle() {
            this.isDsRadio = true
            this.isQrcode = true
        },
        dsMouseOutHandle() {
            this.isDsRadio = false
            this.isQrcode = false
        },
        moveBar(obj, target, time) {
            obj.raf = null;
            var startTime = Date.now();
            var time = time;
            var curNum = -100;
            var target = target;
            if (obj.raf) cancelAnimationFrame(obj.raf);
            //重置

            /*
             * Tween.js
             * t: current time（当前时间）
             * b: beginning value（初始值）
             * c: change in value（变化量）
             * d: duration（持续时间）
             */
            var tween = {
                linear: function(t, b, c, d) {
                    return c * t / d + b;
                },
                easeInQuad: function(t, b, c, d) {
                    return c * (t /= d) * t + b;
                },
                easeOutQuad: function(t, b, c, d) {
                    return -c * (t /= d) * (t - 2) + b;
                },
                easeInOutQuad: function(t, b, c, d) {
                    if ((t /= d / 2) < 1) return c / 2 * t * t + b;
                    return -c / 2 * ((--t) * (t - 2) - 1) + b;
                }
            }
            //var scale=1-Math.max(0,(startTime - changeTime + time)/time);
            var run = () => {
                var changeTime = Date.now() - startTime;
                if (changeTime >= time) {
                    changeTime = time;
                }
                var value = tween.linear(changeTime, curNum, target - curNum, time);
                // var scale = Math.round(((value + 90) / (target + 90)) * 100);
                obj.style[this.transform] = 'translate3d(' + value + '%,0,0)'
                if (changeTime == time) {
                    cancelAnimationFrame(obj.raf);
                    if (this.nowIndex >= this.aMPage.length - 1) {
                        this.nowIndex = 0
                    } else {
                        this.nowIndex++
                    }
                } else {
                    cancelAnimationFrame(obj.raf);
                    obj.raf = requestAnimationFrame(run);
                }
            }
            run();
        },
        downloadMobile() {
            var u = window.navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            console.log(u, isAndroid, isIOS);
            this.isLoading = true;

            //其他浏览器
            if (isIOS) {
                //com.baidu.tieba:// //ios app协议
                window.location.href = "zldd://main";
                setTimeout(() => {
                    this.isLoading = false
                    window.location.href = "https://itunes.apple.com/us/app/%E7%82%B9%E7%82%B9-%E7%82%B9%E4%B8%80%E7%82%B9%E5%B0%B1%E6%9C%89%E9%92%B1/id1259010187?l=zh&ls=1&mt=8";
                }, 1000)
            } else if (isAndroid) {
                //微信
                if (u.match(/MicroMessenger/i) == 'MicroMessenger') {
                    // alert('weixin')
                    // this.isLoading = false;
                    // this.isWxMark = true;
                    window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.zhonglian.diandian";
                    return
                }
                window.location.href = "zldd://main";
                setTimeout(() => {
                    this.isLoading = false
                    window.location.href = this.nowDownloadUrl;
                }, 1000)
            }

        },
        addClass(obj, sClass) {
            if (obj.className) {
                obj.className += ' ' + sClass;
            } else {
                obj.className += sClass;
            }
        },
        removeClass(obj, sClass) {
            var aClass = obj.className.split(' ');
            for (var i = 0; i < aClass.length; i++) {
                if (aClass[i] == sClass) {
                    aClass[i] = '';
                }
            }
            obj.className = aClass.join(' ').replace(/(^\s*)|(\s*$)/g, "")
        },
        setCss3(obj, json) {
            var prefixes = ['Webkit', 'Moz', 'Ms', 'O'];
            for (var sAttr in json) {
                var sAttrUpper = sAttr.charAt(0).toUpperCase() + sAttr.substring(1);
                for (var i = 0; i < prefixes.length; i++) {
                    obj.style[prefixes[i] + sAttrUpper] = json[sAttr];
                }
            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Index.vue?190d8aac